import script from "./BaseButton.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseButton.vue?vue&type=script&setup=true&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=9201f274&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9201f274"]])

export default __exports__